import * as t from 'io-ts';

import {WidgetTypesEnum} from '../../applications/bridge/v2/types/bridgeTypesV2';
import {makeEnumRuntimeType} from '../api/apiTypes';

/*
 * Runtime types.
 */

const RWidgetTemplateDirty = t.exact(
  t.type({
    id: t.string,
    type: makeEnumRuntimeType(WidgetTypesEnum),
  }),
);

/*
 * Types.
 */

export interface WidgetTemplateModel extends Readonly<t.TypeOf<typeof RWidgetTemplateDirty>> {}
export const RWidgetTemplate = t.clean<WidgetTemplateModel>(RWidgetTemplateDirty as any);
